import { fmtTRY } from '../yeni-design/primitives';
import { miktarMetni, oranMetni } from '../satis-analiz/bicim';

/**
 * S334: rapor ekranlarının (Cari Hesap Listesi ve sonraki üç ekran) ortak biçimleri.
 * Para `fmtTRY` (kuruşlu), miktar `miktarMetni`, oran `oranMetni`: yeni biçim İCAT EDİLMEDİ.
 */

/** Kuruşa yuvarlar; -0 döndürmez (fmtTRY "−₺0,00" yazmasın). */
export function yuvarla2(n: number): number {
  const y = Math.round(n * 100) / 100;
  return y === 0 ? 0 : y;
}

/** İşaret yuvarlamadan SONRA: -0,004 "−₺0,00" değil "₺0,00". */
export function paraMetni(n: number): string {
  return fmtTRY(yuvarla2(n));
}

export const sayiMetni = miktarMetni;
export const yuzdeMetni = (n: number) => oranMetni(n, 2);

/**
 * ds tarihi 'YYYY-MM-DD' ya da 'YYYY-MM-DDTHH:mm:ss' gelir. `new Date()` ile ÇEVRİLMEZ: ayna saatleri
 * İstanbul lokali, UTC çevirisi günü bir geri atardı. Metnin ilk on hanesi okunur.
 */
export function tarihMetni(v: string | null | undefined): string {
  if (!v) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : v;
}

/** Türkçe küçük harf (İ -> i, I -> ı); arama iki tarafı da bununla katlar. */
export function kucukTr(s: string): string {
  return s.toLocaleLowerCase('tr-TR');
}

/** API sayıyı metin de döndürebilir (numeric); boş ve bozuk değer 0. */
export function sayiOku(v: unknown): number {
  if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
  if (typeof v === 'string' && v.trim() !== '') {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
}

/** Boş olabilen sayı (vade günü gibi): boş ve bozuk değer null. */
export function sayiOkuBos(v: unknown): number | null {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/** Boş olabilen metin: null, undefined ve yalnız boşluk '' olur. */
export function metinOku(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

export type BorcAlacak = 'B' | 'A' | '-';

/**
 * Borç / alacak işareti. Karar EKRANA YAZILAN (kuruşa yuvarlanmış) bakiyeden verilir: ham değerden
 * verilseydi 0,004 "₺0,00" yazıp "B" gösterirdi (aynı sayı iki anlamda).
 */
export function borcAlacak(bakiye: number): BorcAlacak {
  const y = yuvarla2(bakiye);
  if (Math.abs(y) < 0.005) return '-';
  return y > 0 ? 'B' : 'A';
}
